import { supabase } from '@/lib/supabase'
import type { UserProfileRow, UserProfileUpdatePayload } from '@/types/user-profile'

/**
 * Fetch the current user's profile
 */
export async function fetchUserProfile(userId: string): Promise<UserProfileRow> {
  const { data, error } = await supabase
    .from('user_profiles')
    .select('*')
    .eq('user_id', userId)
    .single()

  if (error) throw error
  return data
}

/**
 * Update the current user's profile
 */
export async function updateUserProfile(
  id: string,
  formData: UserProfileUpdatePayload
): Promise<UserProfileRow> {
  // Build update object, only including fields that were provided
  const updateData: Record<string, unknown> = {}

  if (formData.display_name !== undefined) updateData.display_name = formData.display_name
  if (formData.phone !== undefined) updateData.phone = formData.phone || null
  if (formData.job_title !== undefined) updateData.job_title = formData.job_title || null
  if (formData.timezone !== undefined) updateData.timezone = formData.timezone
  if (formData.notification_preferences !== undefined)
    updateData.notification_preferences = formData.notification_preferences
  if (formData.ui_preferences !== undefined) updateData.ui_preferences = formData.ui_preferences

  const { data, error } = await supabase
    .from('user_profiles')
    .update(updateData)
    .eq('id', id)
    .select()
    .single()

  if (error) throw error
  return data
}
